export class ClientDetailsModel {

    public firstName: string;
    public middleName: string;
    public lastName: string;
    public phone: string;
    public email: string;
    public agreementNo: string;
    public createdTime: string;
    public modifiedTime: string;
    public generalNote: string;
    public noteUpdatedBy: string;
    public salesManagerId: number;
    public salesManager: object;
    public accountManagerId: number;
    public accountManager: object;
    public companyId: number;
    public company: object;
    public countryId: number;
    public country: object;
    public utmCampaign: string;
    public utmKeyword: string;
    public utmMedium: string;
    public utmSource: string;

    constructor(obj?: any) {
        this.firstName          = obj && obj.firstName          || '';
        this.middleName         = obj && obj.middleName         || '';
        this.lastName           = obj && obj.lastName           || '';
        this.phone              = obj && obj.phone              || '';
        this.email              = obj && obj.email              || '';
        this.agreementNo        = obj && obj.agreementNo        || '';
        this.createdTime        = obj && obj.createdTime        || '';
        this.modifiedTime       = obj && obj.modifiedTime       || '';
        this.generalNote        = obj && obj.generalNote        || '';
        this.noteUpdatedBy      = obj && obj.noteUpdatedBy      || '';
        this.salesManagerId     = obj && obj.salesManagerId     || null;
        this.salesManager       = obj && obj.salesManager       || null;
        this.companyId          = obj && obj.companyId          || null;
        this.company            = obj && obj.company            || null;
        this.countryId          = obj && obj.countryId          || null;
        this.country            = obj && obj.country            || null;
        this.accountManagerId   = obj && obj.accountManagerId   || null;
        this.accountManager     = obj && obj.accountManager     || null;
        this.utmCampaign        = obj && obj.utmCampaign        || '';
        this.utmKeyword         = obj && obj.utmKeyword         || '';
        this.utmMedium          = obj && obj.utmMedium          || '';
        this.utmSource          = obj && obj.utmSource          || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/client-details.model.ts